import axios from '@/axios'
import router from '@/router'

const actions = {
  setUser: ({ dispatch, commit, state, rootGetters }, id) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .get(id)
      .then((response) => {
        let user = { ...response }
        commit('user', user)
        // Papéis são POR EVENTO. Garante a lista de eventos carregada ANTES de
        // resolver o evento corrente — senão o fallback (|| 1) carregava os
        // papéis do evento errado (race: botões de juiz apareciam/sumiam
        // conforme o timing do login/refresh).
        const eventsReady = rootGetters['events/getCurrentEventId']
          ? Promise.resolve()
          : dispatch('events/setEvents', null, { root: true })
        return eventsReady.then(() => {
          const eventId = rootGetters['events/getCurrentEventId'] || 1
          return dispatch('setUserEventPermissions', { ...id, event_id: eventId }).then(response => {
            user = { ...user, roles: [...(response || [])] }
            commit('user', user)
            return dispatch('main/setLoading', false, { root: true })
          })
        })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },
  setCleanStore: ({ commit }) =>
    commit('cleanStore'),

  setSignUp: ({ commit, dispatch }, user) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .create(user)
      .then((response) => {
        if (response && response.success) {
          commit('userId', response.user_id)
          router.push('/SignIn')
        }
        dispatch('main/setLoading', false, { root: true })
        return response // devolve o objeto completo p/ a tela exibir o erro real
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setSignIn: ({ commit, dispatch }, user) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .signIn(user)
      .then((response) => {
        if (response.success) {
          commit('userId', response.user_id)
          localStorage.setItem('token', response.token)
          router.push('/UserProfile')
          return true
        } else {
          dispatch('main/setLoading', false, { root: true })
          return response.success
        }
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },
  setUserEventPermissions: ({ commit, dispatch }, ids) => {
    return axios
      .users
      .post
      .getEventRoles(ids)
      .then((response) => {
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },
  setAddEventRole: ({ commit, dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .addEventRole(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true }) // faltava: overlay ficava travado no sucesso
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null // falha (400/403): o caller mostra o erro
      })
  },
  // Edita o próprio perfil (name/email/senha). Em sucesso, recomita o user
  // (mantendo roles/team_id) — a mutation `user` já persiste no localStorage.
  setUpdateUser: ({ commit, dispatch, state }, payload) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .update(payload)
      .then((response) => {
        if (response && response.success) {
          const merged = { ...state.user }
          if (payload.name) merged.name = payload.name
          if (payload.email) merged.email = payload.email
          commit('user', merged)
        }
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  // Define/atualiza o nick do próprio usuário. Em sucesso, recomita o user com o
  // username retornado (a mutation `user` persiste no localStorage).
  setUsername: ({ commit, dispatch, state }, payload) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .setUsername(payload)
      .then((response) => {
        if (response && response.success) {
          commit('user', { ...state.user, username: response.username })
        }
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setRegisterEventParticipants: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .registerEventParticipants(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setUserImage: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .users
      .post
      .setImage(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  fetchUserImage: (context, userId) => {
    return axios
      .users
      .post
      .getImage({ user_id: userId })
      .then((response) => (response && response.image) || '')
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return ''
      })
  },
  setInitialiseStore: ({ commit }) => {
    return commit('initialiseStore')
  }
}

export default actions
